import { FC } from 'react'

import styled from 'styled-components'

import avatar from 'src/Assets/Png/avatar.png'
import dayjs from 'src/Helpers/dayjs'
import { formatDate } from 'src/Constants/formatDate'
import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import { SimpleLabel } from 'src/Components/SimpleLabel'
import { StatusAccruedReferralBonusEnum } from 'src/Redux/referral-process/referralList'
import { PrimaryHint } from 'src/Components/PrimaryHint'
import { numberToMoney } from 'src/Constants/functions'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.color.white};
`

export const BonusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 120px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    position: absolute;
    top: 0;
    right: 0;
  }
`

export const Header = styled.div`
  display: flex;
  max-width: 400px;
  width: 100%;
  padding-right: 16px;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`

export const Avatar = styled.img`
  border-radius: 50%;
  height: 48px;
  width: 48px;
  object-fit: cover;
`

export const Name = styled.span`
  font-family: Segoe UI;
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

export const RegularText = styled.div`
  font-family: Segoe UI;
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

export const BonusText = styled.div`
  font-family: Segoe UI;
  color: ${({ theme }) => theme.color.brandGreen};
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

export const DateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  width: 200px;
  max-width: 320px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

export const StyledLabel = styled(SimpleLabel)<{
  $isPaidCampaign?: boolean
}>`
  background-color: ${({ theme, $isPaidCampaign }) =>
    $isPaidCampaign ? theme.color.lightGreen : theme.color.lightGrey};
  color: ${({ theme, $isPaidCampaign }) =>
    $isPaidCampaign ? theme.color.darkGreen : theme.color.darkGrey};
`

export interface RewardsDetailsItemProps {
  name: string
  date: string
  email: string
  status: StatusAccruedReferralBonusEnum
  bonus?: number
}

export const RewardsDetailsItem: FC<RewardsDetailsItemProps> = ({
  name,
  email,
  status,
  date,
  bonus,
}) => {
  const registerDate = dayjs(date).format(formatDate.formatDate1)
  const isPaidCampaign = status === StatusAccruedReferralBonusEnum.PAID
  const statusText = isPaidCampaign ? 'Campaign paid' : 'Campaign unpaid'
  const bonusValue = `+ $${numberToMoney(bonus)}`

  return (
    <Wrapper>
      <Header>
        <Avatar src={avatar} alt='avatar' height={48} width={48} />
        <InfoWrapper>
          <NameWrapper>
            <Name>{name}</Name>
            <RegularText>{email}</RegularText>
          </NameWrapper>
          <StyledLabel $isPaidCampaign={isPaidCampaign}>
            {statusText}
          </StyledLabel>
        </InfoWrapper>
      </Header>
      <DateContainer>
        <RegularText>{`Joined on ${registerDate}`}</RegularText>
      </DateContainer>
      <BonusContainer>
        {isPaidCampaign ? (
          <BonusText>{bonusValue}</BonusText>
        ) : (
          <PrimaryHint>
            The bonus will be added after the artist pays for their first
            campaign.
          </PrimaryHint>
        )}
      </BonusContainer>
    </Wrapper>
  )
}
